import { FunctionComponent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { RelatedTag } from '@/types';
import { trackFeature } from '@/utils/adobeLaunch';
import { fetchRelatedTags } from '@/utils/http/fetchRelatedTags';
import { t } from '@/utils/i18n';
import { LIST_ROUTE, addSearchTermToRoute } from './DesignSelector';
import './RelatedTags.scss';

interface Props {
  searchTerm: string;
}

export const RelatedTags: FunctionComponent<Props> = ({ searchTerm }) => {
  const [relatedTags, setRelatedTags] = useState<RelatedTag[]>([]);

  useEffect(() => {
    fetchRelatedTags(searchTerm).then((relatedTags) => {
      setRelatedTags(relatedTags.slice(0, 10));
    });
  }, [searchTerm]);

  if (!relatedTags.length) {
    return null;
  }

  return (
    <div className="related-tags">
      <h4 className="related-tags__heading">{t('designSelector.relatedTags')}</h4>
      <div className="related-tags__item-container">
        <ul className="related-tags__items">
          {relatedTags.map((tag) => (
            <li key={tag.tagId}>
              <Link
                to={addSearchTermToRoute(LIST_ROUTE, tag.name)}
                className="related-tags__action"
                onClick={() => trackFeature('design-selection-related-tag')}
              >
                {tag.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
